import { render, staticRenderFns } from "./TaxAdministrationCreateOrUpdate.vue?vue&type=template&id=b73e95c0&"
import script from "./TaxAdministrationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TaxAdministrationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports